<template>
  <div class="grid-container full">
    <div class="grid-x">
      <div class="small-12 cell text-center">
        <h2>We help Rare candidates apply to these firms & institutions</h2>
      </div>
    </div>

    <div class="grid-x show-for-medium carouselCont page-contents-8">
      <div class="shrink cell text-left carouselLinkCont">
        <a tabindex="70" href="#" @click.prevent="changPane('business')" class="carouselLink"
           :class="{selected: paneToShow === 'business'}">BUSINESS & FINANCE</a>
      </div>
      <div class="shrink cell text-left carouselLinkCont">
        <a tabindex="71" href="#" @click.prevent="changPane('law')" class="carouselLink"
           :class="{selected: paneToShow === 'law'}">LAW</a>
      </div>
      <div class="shrink cell text-left carouselLinkCont">
        <a tabindex="72" href="#" @click.prevent="changPane('uni')" class="carouselLink"
           :class="{selected: paneToShow === 'uni'}">UNIVERSITIES</a>
      </div>
    </div>

    <div class="grid-x show-for-small-only carouselCont page-contents-8">
      <div class="small-12 cell">
        <select class="logoSector" v-model="paneToShow">
          <option value="business">BUSINESS & FINANCE</option>
          <option value="law">LAW</option>
          <option value="uni">UNIVERSITIES</option>
        </select>
      </div>
    </div>

    <div v-if="paneToShow === 'business'">
      <div class="grid-x carouselPane align-justify align-middle page-contents-8 icon-row">
        <div class="small-12 medium-auto cell text-center medium-text-left">
            <img
              style="max-height: 24px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BainCompany.png" alt="Bain Company"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 43px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/Barclays.png" alt="Bain Company"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 40px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/BCG.png" alt="BCG"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 70px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/bp.png" alt="BP"/>
        </div>
        <div class="small-12 medium-auto cell text-center medium-text-left">
          <img
            style="max-height: 26px;"
            class="clientImg small-logo-margin-bump"
            src="@/assets/img/logos/home-page-logos/DeutscheBank.png" alt="Deutsche Bank"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle page-contents-8 icon-row">
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 50px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/jane-street.png" alt="Jane Street"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 30px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/JPMorgan.png" alt="JP Morgan"/>
        </div>

        <div class="small-12 medium-auto cell text-center">
          <img
            style="max-height: 48px;"
            class="clientImg small-logo-margin-bump"
            src="@/assets/img/logos/home-page-logos/mckinsey-company.png" alt="McKinsey & Company"/>
        </div>

        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 25px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/MorganStanley.png" alt="Morgan Stanley"/>
        </div>
        <div class="small-12 medium-auto cell text-center medium-text-right">
            <img
              style="max-height: 20px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/OliverWyman.png" alt="Oliver Wyman"/>
        </div>
      </div>
      <div class="small-bottom-spacer">&nbsp;</div>
    </div>

    <div v-if="paneToShow === 'law'">
      <div class="grid-x carouselPane align-justify align-middle page-contents-8 icon-row">
        <div class="small-12 medium-auto cell text-center medium-text-left">
            <img
              style="max-height: 16px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/a-o-shearman.png" alt="Allen & Overy"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="height: 26px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/Ashurst.png" alt="Ashurst"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 43px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/CliffordChance.png" alt="Clifford Chance"/>
        </div>
        <div class="small-12 medium-auto cell text-center medium-text-right">
            <img
              style="max-height: 33px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/Freshfields.png" alt="Freshfields"/>
        </div>
      </div>
      <div class="grid-x align-justify align-middle page-contents-8 icon-row">
        <div class="small-12 medium-auto cell text-center medium-text-left">
            <img
              style="max-height: 56px;"
              class="clientImg small-logo-margin-bump-new-line"
              src="@/assets/img/logos/home-page-logos/HSF.png" alt="HSF"/>
        </div>
        <div class="small-12 medium-auto cell text-center medium-text-left">
            <img
              style="max-height: 63px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/HoganLovells.png" alt="Hogan Lovells"/>
        </div>
        <div class="small-12 medium-2 cell text-center">
            <img
              style="max-height: 15px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/LathamWatkins.png" alt="Latham & Watkins"/>
        </div>
        <div class="small-12 medium-auto cell text-center medium-text-right">
            <img
              style="max-height: 23px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/Linklaters.png" alt="Linklaters"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle page-contents-8 icon-row">
        <div class="small-12 medium-auto cell text-center medium-text-left">
            <img
              style="max-height: 15px;"
              class="clientImg small-logo-margin-bump-new-line"
              src="@/assets/img/logos/home-page-logos/Macfarlanes.png" alt="Macfarlanes"/>
        </div>

        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 28px;"
              class="clientImg small-logo-margin-bump-new-line"
              src="@/assets/img/logos/home-page-logos/mishcon-de-reya.png" alt="Mishcon de Reya"/>
        </div>

        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 16px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/SlaughterAndMay.png" alt="Slaughter And May"/>
        </div>
        <div class="small-12 medium-auto cell text-center">
            <img
              style="max-height: 38px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/TraversSmith.png" alt="Travers Smith"/>
        </div>
        <div class="small-12 medium-auto cell text-center medium-text-right">
            <img
              style="max-height: 15px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/White&Case.png" alt="White & Case"/>
          <div class="small-bottom-spacer">&nbsp;</div>
        </div>
      </div>
    </div>

    <div v-if="paneToShow === 'uni'">
      <div class="grid-x carouselPane align-justify align-middle page-contents-8 icon-row">
        <div class="small-12 medium-4 cell text-center text-left-medium">
            <img
              style="max-height: 90px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/OxfordUniversityLarge.png" alt="Oxford University"/>
        </div>
        <div class="small-12 medium-4 cell text-center">
            <img
              style="max-height: 90px;"
              class="clientImg small-logo-margin-bump"
              src="@/assets/img/logos/home-page-logos/CambridgeUniversityLarge.jpg" alt="Cambridge University"/>
          <div class="small-bottom-spacer">&nbsp;</div>
        </div>
        <div class="small-12 medium-4 cell text-center text-right-medium">
            <img
              style="max-height: 80px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BathUniversity.png" alt="Bath University"/>
          <div class="small-bottom-spacer">&nbsp;</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'RareCandidatesClientsCarousel',
  methods: {
    changPane(newPane) {
      this.paneToShow = newPane;
    },
  },
  data() {
    return {
      paneToShow: 'business',
    };
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: #ffffff;
  }

  .carouselLinkCont {
    padding-bottom: 19px;
    width: 32%;
  }

  .carouselLinkCont:last-child {
    padding-right: 0;
  }

  a.carouselLink {
    color: #4d5b67;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 4px;
    padding-bottom: 19px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
  }

  .selected {
    border-bottom: 4px solid $green-highlight;
    font-weight: bold !important;
  }

  h2
  {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  .logoSector {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMzMjNDNDQiIGQ9Ik0xNi42IDhMMTIgMTIuNiA3LjQgOCA2IDkuNGw2IDYgNi02eiIvPgogICAgPC9nPgo8L3N2Zz4K");
    background-size: auto;
    border: none;
    border-bottom: 4px solid $green-highlight;
    display: block;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 4px;
    text-align: center;
  }

  .logoSector:focus {
    box-shadow: none;
  }


  @media only screen and (max-width: 1120px)  {
    .page-contents-8 {
      padding: 2% !important;
    }
  }

  @media only screen and (max-width: 640px)  {

    .carouselCont {
      margin-bottom: 30px;
      padding-bottom: 19px;
    }

    h2 {
      font-size: 28px;
      line-height: 1.43;
      letter-spacing: 0.2px;
      margin: 20px 0 20px 0;
    }

    .icon-row {
      margin-bottom: 0;
      padding-bottom: 0;
    }

    .small-logo-margin-bump {
      margin-top: 40px;
    }

    .small-logo-margin-bump-new-line {
      margin-top: 25px;
    }

    .small-bottom-spacer {
      margin-bottom: 40px;
    }

    .last-logo {
      margin-bottom: 40px;
    }
  }

  @media only screen and (min-width: 641px) {

    .carouselCont {
      width: 100%;
      border-bottom: 2px solid #c5cace;
      margin-bottom: 30px;
      padding-bottom: 19px;
      display: flex;
      justify-content: space-between;
    }

    h2 {
      font-size: 48px;
      line-height: 1.33;
      letter-spacing: normal;
      margin: 30px auto 72px auto;
    }

    .carouselLinkCont {
      text-align: center;
    }

    .icon-row {
      margin-bottom: 80px;
    }

    .small-logo-margin-bump {
      margin-top: 0;
    }

    .small-bottom-spacer {
      margin-bottom: 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesClientsCarousel.vue